import { i18WithDefault as t } from './locales'
import { Types } from 'service-api'

export const getPayFacTypeLabel = (
  payFacType?: Types.OrderPaymentClientDto['payFacType'] | Types.OrderPaymentAdminDto['payFacType']
) => {
  if (!payFacType) return ''
  if (payFacType === 'ADYEN' || payFacType === 'TILLED') return t('payment.label.card')
  return t('payment.label.wallet')
}

export const getTxnPayFacTypesApplied = (
  transactions?: Types.PaymentTransactionClientDto[] | Types.PaymentTransactionAdminDto[]
) => {
  if (!transactions) return []
  const payFacTypes = new Set(transactions.map((transaction) => transaction.orderPayment?.payFacType))
  return Array.from(payFacTypes)
}

export const getPaymentPayFacTypesApplied = (
  payments?: Types.OrderPaymentClientDto[] | Types.OrderPaymentAdminDto[]
) => {
  if (!payments) return []
  const payFacTypes = new Set(payments.map((payment) => payment.payFacType))
  return Array.from(payFacTypes)
}

export const getInvoiceTxns = (
  payments?: Types.OrderPaymentClientDto[] | Types.OrderPaymentAdminDto[]
): Map<string | null, Types.PaymentTransactionClientDto[] | Types.PaymentTransactionAdminDto[]> => {
  if (!payments) return new Map()
  const orderTransactions = payments.flatMap(
    (payment) => payment.transactions?.map((transaction) => ({ ...transaction, orderPayment: payment })) || []
  )
  const invoiceTxns = new Map<string | null, Types.PaymentTransactionClientDto[] | Types.PaymentTransactionAdminDto[]>()

  orderTransactions.forEach((txn) => {
    const invoiceTxn = invoiceTxns.get(txn.invoiceId!)

    if (invoiceTxn) {
      invoiceTxn.push(txn)
    } else {
      invoiceTxns.set(txn.invoiceId!, [txn])
    }
  })

  return invoiceTxns
}
